import React, { useEffect, useState } from 'react'

import PropTypes from 'prop-types'
import { TextField, Box, Button, Grid, makeStyles } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'

import { Label } from 'components'
import { TableCountries, SkeletonCountries } from './components'

import useSelectCountry from 'hooks/useSelectCountry'

import styles from './styles'

const SelectCountry = ({
  withTable,
  withAddButton,
  label,
  handleRemoveCountry,
  manyFields,
  fieldName,
  disabled,
  confirmBeforeRemove,
}) => {
  const {
    countries,
    loading,
    loadCountries,
    selectedCountries,
    setSelectedCountries,
    addCountry,
    manySelectedCountries,
    addCountryToManyFields,
  } = useSelectCountry()

  const useStyles = makeStyles(styles)
  const classes = useStyles()

  const [pendingCountry, setPendingCountry] = useState(null)

  useEffect(() => {
    setSelectedCountries(selectedCountries || [])

    if (countries.length <= 0) loadCountries()

    // eslint-disable-next-line
  }, [])

  const handleAddPendingCountry = () => {
    if (!pendingCountry) return

    addCountry(pendingCountry)
    setPendingCountry(null)
  }

  const handleKeyDownAddCountry = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault()
      if (pendingCountry) {
        handleAddPendingCountry()
      }
    }
  }

  if (manyFields) {
    return (
      <>
        {loading ? (
          <SkeletonCountries
            withTable={withTable}
            label={disabled ? '' : label}
          />
        ) : (
          <Box>
            {!disabled && (
              <Label description={label} item>
                <Autocomplete
                  options={countries || []}
                  getOptionLabel={(countryOption) => countryOption.name || ''}
                  getOptionSelected={(countryOption, value) =>
                    !value || countryOption.id === value.id || value.id === 0
                  }
                  onChange={(event, newInputValue) => {
                    addCountryToManyFields(newInputValue, fieldName)
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      className={classes.internationalTransferSelect}
                      variant="outlined"
                    />
                  )}
                />
              </Label>
            )}
            {withTable && (
              <Box mt={2}>
                <TableCountries
                  manyFields
                  disabled={disabled}
                  fieldName={fieldName}
                  countries={
                    manySelectedCountries
                      ? manySelectedCountries[fieldName]
                      : []
                  }
                  handleRemoveCountry={handleRemoveCountry}
                />
              </Box>
            )}
          </Box>
        )}
      </>
    )
  }

  return (
    <>
      {loading ? (
        <SkeletonCountries
          withTable={withTable}
          withAddButton={withAddButton}
          label={disabled ? '' : label}
        />
      ) : (
        <Box>
          {!disabled &&
            (withAddButton ? (
              <Grid container spacing={2} alignItems="center">
                {label && (
                  <Grid item xs={12}>
                    <Label description={label} />
                  </Grid>
                )}
                <Grid item xs={9} md={10}>
                  <Autocomplete
                    autoHighlight
                    value={pendingCountry}
                    options={countries || []}
                    getOptionLabel={(countryOption) => countryOption.name || ''}
                    getOptionSelected={(countryOption, value) =>
                      !value || countryOption.id === value.id || value.id === 0
                    }
                    onChange={(event, newInputValue) => {
                      setPendingCountry(newInputValue)
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        disabled={disabled}
                        className={classes.internationalTransferSelect}
                        variant="outlined"
                        onKeyDown={handleKeyDownAddCountry}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={3} md={2}>
                  <Button
                    onClick={handleAddPendingCountry}
                    color="primary"
                    variant="contained"
                    type="button"
                    fullWidth
                  >
                    Adicionar
                  </Button>
                </Grid>
              </Grid>
            ) : (
              <Label description={label} item>
                <Autocomplete
                  options={countries || []}
                  getOptionLabel={(countryOption) => countryOption.name || ''}
                  getOptionSelected={(countryOption, value) =>
                    !value || countryOption.id === value.id || value.id === 0
                  }
                  onChange={(event, newInputValue) => {
                    addCountry(newInputValue)
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      disabled={disabled}
                      className={classes.internationalTransferSelect}
                      variant="outlined"
                    />
                  )}
                />
              </Label>
            ))}
          {withTable && (
            <Box mt={2}>
              <TableCountries
                disabled={disabled}
                countries={selectedCountries}
                handleRemoveCountry={handleRemoveCountry}
                confirmBeforeRemove={confirmBeforeRemove}
              />
            </Box>
          )}
        </Box>
      )}
    </>
  )
}

SelectCountry.propTypes = {
  withTable: PropTypes.bool,
  withAddButton: PropTypes.bool,
  label: PropTypes.string,
  handleRemoveCountry: PropTypes.func,
  manyFields: PropTypes.bool,
  fieldName: PropTypes.string,
  disabled: PropTypes.bool,
  confirmBeforeRemove: PropTypes.bool,
}

SelectCountry.defaultProps = {
  withTable: false,
  withAddButton: false,
  label: '',
  handleRemoveCountry: () => {},
  manyFields: false,
  disabled: false,
  confirmBeforeRemove: false,
}

export default SelectCountry
